import { c as _c } from "react/compiler-runtime";
import { TabsWithRoutes } from "@components/common/tabs/tabs-with-routes";
import { CircularProgress } from "@flat-ui";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { NotFoundPage } from "@pages/not-found-page";
import { ExportWorkspaceOrProjects } from "@pages/settings/export-workspace/export-workspace-or-project";
import { GeneralSettings } from "@pages/settings/general-settings/general-settings";
import { SubscriptionSettings } from "@pages/settings/subscription-settings/subscription-settings";
import { SettingsTabs } from "@router/route-params";
import { useAppParams } from "@router/router-helper";
import { RequiredFeatureCompanyLevelName } from "@utils/feature-control/company/company-feature-control-types";
import { OpenTabEvents } from "@utils/track-event/track-event-list";

/** Content in the Workspace Settings page */
export function WorkspaceSettingsPage() {
  const $ = _c(9);
  const {
    settingsTab
  } = useAppParams();
  const {
    canExportWorkspace: canExportWorkspaceFeature
  } = useHasUserValidFeatureCompanyLevel();
  const {
    canExportWorkspace: canExportWorkspaceRole
  } = useHasUserValidRoleCompanyLevel();
  if (!settingsTab || !Object.values(SettingsTabs).includes(settingsTab)) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <NotFoundPage />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      label: "General",
      route: SettingsTabs.general,
      content: _temp,
      loadingContent: <CircularProgress />
    };
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      label: "Subscription",
      route: SettingsTabs.subscription,
      content: _temp2,
      loadingContent: <CircularProgress />
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CircularProgress />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = !canExportWorkspaceFeature || !canExportWorkspaceRole;
  let t4;
  if ($[4] !== t3) {
    t4 = [t0, t1, {
      label: "Export",
      route: SettingsTabs.export,
      content: _temp3,
      loadingContent: t2,
      requiredFeatureCompanyLevel: RequiredFeatureCompanyLevelName.canExportWorkspace,
      isHidden: t3
    }];
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const tabs = t4;
  let t5;
  if ($[6] !== settingsTab || $[7] !== tabs) {
    t5 = <TabsWithRoutes dataTestId="WORKSPACE_SETTINGS_CONTAINER" selectedTab={settingsTab} requiredAttribute={false} trackingEventPageName={OpenTabEvents.openWorkspaceSettingsTab} tabs={tabs} />;
    $[6] = settingsTab;
    $[7] = tabs;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
function _temp3() {
  return <ExportWorkspaceOrProjects entityName="workspace" />;
}
function _temp2() {
  return <SubscriptionSettings />;
}
function _temp() {
  return <GeneralSettings />;
}